import { render } from "./partnerdetail.vue?vue&type=template&id=594ebef8&scoped=true"
import script from "./partnerdetail.vue?vue&type=script&lang=js"
export * from "./partnerdetail.vue?vue&type=script&lang=js"

import "./partnerdetail.vue?vue&type=style&index=0&id=594ebef8&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594ebef8"]])

export default __exports__